import { render } from "./EwgDialog.vue?vue&type=template&id=660b6915&scoped=true"
import script from "./EwgDialog.script.ts?vue&type=script&lang=ts"
export * from "./EwgDialog.script.ts?vue&type=script&lang=ts"

import "./EwgDialog.vue?vue&type=style&index=0&id=660b6915&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-660b6915"

export default script